export default class ResultsTransferCtrlList {

  constructor ($scope, $timeout, $mdDialog, $cookies, WorkPlanSrv, WorkPlanModalSrv, $stateParams, WorkPlanIndicatorSrv, GlobalConfig, Requests, $sessionStorage) {
  	var resultsTransferListVm = this
    const currentUser = JSON.parse($cookies.get('currentUser'))
    let post = {
      workplanId: currentUser.workplanId,
      teacherId: currentUser.teacherId
    }
    //Variables
    resultsTransferListVm.viewLoaded = false
    resultsTransferListVm.active = GlobalConfig.generals.active
    resultsTransferListVm.notActive = GlobalConfig.generals.notActive
    resultsTransferListVm.planningFinish = true
  	resultsTransferListVm.transfers = []
    $scope.classPlanning = ''
    resultsTransferListVm.feedback = 0
    resultsTransferListVm.imgEmpty = require('../../../../../../assets/images/empty_state_illustration.svg')
    
    //Methods
    resultsTransferListVm.updateView = updateView
    resultsTransferListVm.gradRoleClass = 'grad-4'
  	resultsTransferListVm.confirmDeleteTransfer = confirmDeleteTransfer
    resultsTransferListVm.getGeneralsWorkplan = getGeneralsWorkplan
    resultsTransferListVm.bitacora = bitacora
    resultsTransferListVm.workPlanGeneralList = $sessionStorage.workPlanGeneralList
    resultsTransferListVm.$sessionStorage = $sessionStorage

  	resultsTransferListVm.carouselResponsiveBreakpoints = [
      {
        breakpoint: 1360,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }, {
        breakpoint: 1366,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }, {
        breakpoint: 1920,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }, {
        breakpoint: 3000,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      }
    ]

    active()

    function active(){
      if(resultsTransferListVm.workPlanGeneralList != undefined){
        resultsTransferListVm.status = resultsTransferListVm.workPlanGeneralList.wokplanTeacherStatus[0]
        resultsTransferListVm.stages = resultsTransferListVm.workPlanGeneralList.stages
        resultsTransferListVm.inReview = resultsTransferListVm.status.reviewed
        resultsTransferListVm.feedback = resultsTransferListVm.status.feedbackReviewed
        resultsTransferListVm.workplanTeacherId = resultsTransferListVm.status.workplanTeacherId
        isPlanning(resultsTransferListVm.status, resultsTransferListVm.stages)

        if(resultsTransferListVm.feedback && !resultsTransferListVm.planningFinish){
          getDataFormTransferResultsReject()
        }else{
          getDataFormTransferResults()
        }
      }else{
        getGeneralsWorkplan(post).then((promise) => {
          if(resultsTransferListVm.feedback && !resultsTransferListVm.planningFinish){
            getDataFormTransferResultsReject()
          }else{
            getDataFormTransferResults()
          }
        })
      }

      updateView()
    }

    function getDataFormTransferResults(){
      WorkPlanSrv.getDataFormTransferResults.getList(post).$promise.then(
        dataReturn => {
          if (dataReturn.status) {
            resultsTransferListVm.transfers = dataReturn.listActivitiesResults
          }else{
            console.log("Comunications problem")
          }
        },
        data => {
          console.log(data)
        }
      )
    }

    function getDataFormTransferResultsReject(){
      WorkPlanSrv.getDataFormTransferResultsReject.getList(post).$promise.then(
        dataReturn => {
          if (dataReturn.status) {
            resultsTransferListVm.transfers = dataReturn.listActivitiesResults
          }else{
            console.log("Comunications problem")
          }
        },
        data => {
          console.log(data)
        }
      )
    }

    function updateView () {
      resultsTransferListVm.viewLoaded = false
      $timeout(() => {
        resultsTransferListVm.viewLoaded = true
      }, 1)
    }

    function getGeneralsWorkplan(post){
      return WorkPlanSrv.getElementsRightBar.getList({teacherId: post.teacherId}).$promise.then(function(dataReturn) {
        if(dataReturn.status){
          resultsTransferListVm.$sessionStorage.workPlanGeneralList = dataReturn.data
          resultsTransferListVm.status = dataReturn.data.wokplanTeacherStatus[0]
          resultsTransferListVm.stages = dataReturn.data.stages
          resultsTransferListVm.inReview = resultsTransferListVm.status.reviewed
          resultsTransferListVm.feedback = resultsTransferListVm.status.feedbackReviewed
          resultsTransferListVm.workplanTeacherId = resultsTransferListVm.status.workplanTeacherId
          isPlanning(resultsTransferListVm.status, resultsTransferListVm.stages)
        }else{
          console.log("Comunications problem with the server")
        }
      },function(data) {
           console.log(data);
      })
    }

    function isPlanning (status, stages) {
      resultsTransferListVm.currentDate = moment(new Date()).format('DD/MM/YYYY')
      for (var i = stages.length - 1; i >= 0; i--) {
        if (stages[i].stageId == GlobalConfig.workplanIdStages.review) {
          resultsTransferListVm.startDateStage = stages[i].startDate
        }
      }

      if(status.workplanActive){
        if (status.planningFinish == resultsTransferListVm.active) {        
          resultsTransferListVm.planningFinish = true
          if (resultsTransferListVm.startDateReview < resultsTransferListVm.currentDate || status.reviewedFinish == resultsTransferListVm.active) {
            resultsTransferListVm.planningFinish = true
          } else if (status.reviewedReject == resultsTransferListVm.active){
            resultsTransferListVm.planningFinish = false
          }
        } else {
          resultsTransferListVm.planningFinish = false
        }
      }else{
        resultsTransferListVm.planningFinish = true
      }

      $scope.classPlanning = (resultsTransferListVm.planningFinish ? "disabled" : " ")
    }

    function confirmDeleteTransfer (item) {
      let transferName = item.name
      let workplanTeacherActivityId = item.workplanTeacherActivityId
      $mdDialog.show({
        controller: ['$scope', '$mdDialog', 'WorkPlanIndicatorSrv', function ($scope, $mdDialog, WorkPlanIndicatorSrv) {
          let ctrlModalVM = this
          ctrlModalVM.transferName = transferName
          ctrlModalVM.workplanTeacherActivityId = workplanTeacherActivityId
          ctrlModalVM.close = function () {
            $mdDialog.hide()
          }
          ctrlModalVM.delete = function () {
            WorkPlanSrv.disableActivityResearch.delete({workplanTeacherActivityId: ctrlModalVM.workplanTeacherActivityId})
            .$promise.then(function (dataReturn) {
              if (dataReturn.status) {
                removeFromCaroussel(item)
                showDeletedSuccessfully(ctrlModalVM.transferName)
                WorkPlanIndicatorSrv.setVariable(true)
                $mdDialog.hide()
              } else {
                console.log('Comunications problem with the server')
              }
            }, function (data) {
              
            })
          }
        }],
        controllerAs: 'ctrlModalVM',
        template: require('./deleteResultsTransferModal.html'),
        clickOutsideToClose: false
      })
    }

    function showDeletedSuccessfully(transferName){
      let texts = GlobalConfig.appTexts
      let header = {
        createOrEdit     : texts.deleteDialog,
        textCreateOrEdit : texts.deleted,
        itemName         : transferName,
        nameModal        : texts.modalTypeName.deleted,
        modalType        : texts.modalTypeId.default
      }
      WorkPlanModalSrv.setVariableSuccessDialog(header)
      WorkPlanModalSrv.successDialog(header).then((promise) => { })      
    }

    function removeFromCaroussel(item){
      for(var i in resultsTransferListVm.transfers){
        if(resultsTransferListVm.transfers[i].workplanTeacherActivityId === item.workplanTeacherActivityId){
          resultsTransferListVm.transfers.splice(i,1)
          updateView()
          break
        }
      }
    }

    function bitacora (ev) {
      let entries = {}

      entries.params = {
        activityTypeId: GlobalConfig.activityTypeId.resultsTransfer,
        workplanTeacherId: resultsTransferListVm.workplanTeacherId
      }
      entries.title = 'Transferencia de resultados'
      // Entries(this.entries);
      entries.data = undefined
      $mdDialog.show({
        controller: 'bitacoraModalCtrl',
        controllerAs: 'bit',
        template: require('../../../../strategicTracking/detailsByTeacher/bitacoraModal/bitacoraModal.html'),
        parent: angular.element(document.body),
        targetEvent: ev,
        locals: {data: entries},
        clickOutsideToClose: true,
        fullscreen: true
      })
    }
  }
}
ResultsTransferCtrlList.$inject = ['$scope', '$timeout', '$mdDialog', '$cookies', 'WorkPlanSrv', 'WorkPlanModalSrv', '$stateParams', 'WorkPlanIndicatorSrv', 'GlobalConfig', 'Requests', '$sessionStorage'];


// WEBPACK FOOTER //
// ./src/app/u-faculty/workplan/research/resultsTransfer/list/resultsTransferListCtrl.js